/* eslint-disable */
export default {
  noActiveCalls: 'Sem chamadas ativas',
  currentCall: 'Chamada atual',
  ringCall: 'Chamada a tocar',
  onHoldCall: 'Chamada em espera',
  otherDeviceCall: 'Chamadas em curso nos outros dispositivos',
  confirmation: 'Confirmação',
  confirmMergeToConference: 'Adicionar a chamada de conferência?',
  mergeToConference: 'Unir',
  conferenceCall: 'Chamada de conferência',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
